<template>
    <font-awesome-icon v-if="isLoading" icon="spinner" spin/>
    <div v-else>
        <b-row>
            <b-col cols="12" md="4">
                <b-button v-for="state in $store.state.productStates" :key="state.identifier"
                          variant="primary" @click="submit(state.identifier)"
                          class="d-block w-100 mb-3"
                          :disabled="!!isProcessing"
                >
                    {{ state.display_name }}
                    <font-awesome-icon v-if="state.identifier === isProcessing" icon="spinner" spin class="ml-2"/>
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {UsesProductProcessApi} from "./UsesProductProcessApi";
import {PRODUCT_PROCESS_TYPE_RETURN, PRODUCT_PROCESS_TYPE_SORT} from "../../../data/productProcessType";

export default {
    name: "CheckSellable",

    props: {
        storageZoneIdentifier: {required: true, type: String},
        locationTypeIdentifier: {required: true, type: String},
        locationIdentifier: {required: true, type: String},
        processType: {required: true, type: String},
        productEan: {required: true, type: String},
    },

    data() {
        return {
            isLoading: true,
            isProcessing: false,
        }
    },

    computed: {},

    mounted() {
        this.$store.getters.getProductStates
            .then(() => {
                this.isLoading = false
            })
    },

    methods: {
        submit(state) {
            this.isProcessing = state
            this.$http.get(`/api/rest/locations/${this.locationTypeIdentifier}/${this.locationIdentifier}/storage-locations/${this.storageZoneIdentifier}/process-product/${this.processType}/scan/${this.productEan}`, {
                params: {
                    product_state_identifier: state,
                }
            })
                .then(response => {
                    this.$emit('success', state, response.data.storage_location)
                })
                .catch(e => {
                    console.error(e)
                    this.$alert('Fout bij het ophalen van de legplaats', 'danger');
                })
                .then(() => this.isProcessing = false)
        },
    },
}
</script>

<style scoped>

</style>
